import { render, staticRenderFns } from "./ReviewsSlider.vue?vue&type=template&id=cf8cb8be&scoped=true&"
import script from "./ReviewsSlider.vue?vue&type=script&lang=js&"
export * from "./ReviewsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsSlider.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ReviewsSlider.vue?vue&type=style&index=1&id=cf8cb8be&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8cb8be",
  null
  
)

export default component.exports